import { Controller } from "@hotwired/stimulus"
import { CARD_SELECTOR, UNITS_SELECTOR, bars, confirmedByBar, readBar, readCards, writeCards, writeUnits } from "../modules/card_action.mjs"
import { rememberBar } from "../modules/native_cart_resume"

// Contenedor de la barra: unidades por producto y versión del carrito; al entrar confirma las tarjetas
// (salvo las en vuelo) y pinta el número de las tarjetas con opciones. Doc: _docs/frontend/catalog_presentation/storefront_quick_add.md → Decisiones (versión en la barra)
export default class extends Controller {
  static values = { units: Object, version: Number }

  connect() {
    const accountId = document.querySelector(".account-data")?.dataset.accountId
    const painted = readBar(this.element)
    const latest = bars.latestFor(accountId) // solo esta cuenta
    if (latest?.element && painted.version < latest.version) {
      this.element.replaceWith(latest.element.cloneNode(true)) // conecta de nuevo, ya al día
      return
    }
    const forms = document.querySelectorAll(CARD_SELECTOR)
    const busy = Array.from(forms).filter(form => form.hasAttribute("aria-busy")).map(form => form.dataset.productId)
    writeCards(forms, confirmedByBar(readCards(forms), this.unitsValue, busy))
    writeUnits(document.querySelectorAll(UNITS_SELECTOR), this.unitsValue)
    bars.note({ ...painted, accountId, element: this.element })
    rememberBar(this.element, accountId)
  }

  // turbo:before-stream-render: entra solo una barra más nueva que la pintada
  acceptNewer(event) {
    if (event.target.getAttribute("target") !== this.element.id) return
    const container = event.target.templateContent?.firstElementChild
    const incoming = container && readBar(container)
    if (!incoming || incoming.version <= this.versionValue) return event.preventDefault()
    bars.note({ ...incoming, accountId: document.querySelector(".account-data")?.dataset.accountId, element: container })
  }
}
